<template>
<v-container class="fill-height" style="display: block;" fluid>
    <v-window v-model="windowPage" style="width: 100%;" touchless>

        <v-window-item :key="0">
            <div id="ag-grid-container">
                <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                    :gridOptions="gridOptions"
                    @row-double-clicked="(params) => editSiteGroup(params.data)"
                    :groupHeaders="true"
                    :rowHeight="40">
                </ag-grid-vue>
            </div>
            <v-btn color="#c42111" class="mt-3 mr-3" @click="newSiteGroup" :disabled="lockSave" v-if="showGrid">New</v-btn>
            <div class="admin-page-grid-center-buttons-container" v-if="showGrid">
                <div class="admin-page-grid-center-buttons-container-label">
                    <span>Grid Display</span>
                </div>
                <v-tooltip top color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn class="mr-3" fab dark x-small color="#c42111" @click="saveGridModifications" title="Save Grid Modifications" v-on="on">
                            <v-icon>mdi-content-save</v-icon>
                        </v-btn>
                    </template>
                    <span>Save Grid Modifications</span>
                </v-tooltip>
                <v-tooltip top color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn class="" fab dark x-small color="#c42111" @click="clearGridModifications" title="Clear Grid Modifications" v-on="on">
                            <v-icon>mdi-layers-remove</v-icon>
                        </v-btn>
                    </template>
                    <span>Clear Grid Modifications</span>
                </v-tooltip>
            </div>
        </v-window-item>

        <v-window-item :key="1">
            <site-group-edit :siteGroup="selectedSiteGroup" :lockSave="lockSave" @save="saveSiteGroup" @cancel="windowPage = 0"></site-group-edit>
        </v-window-item>
    

    </v-window>
</v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import SiteGroupEdit from "@/components/SiteGroups/SiteGroupEdit";
export default {
    name: 'SiteGroups',
    props: [''],
    components: {
        'ag-grid-vue': AgGridVue,
        SiteGroupEdit
    },
    data: () => ({
        showGrid: false,
        siteGroupsList: [],
        savedSiteGroupIndex: null,
        windowPage: 0,
        lockSave: false,
        selectedSiteGroup: null,
        gridOptions: null,
        gridModifications: null
    }),

    computed: {

    },

    methods: {
        getSiteGroupsList: function() {
            this.showGrid = false;
            let route = (TELSA.apiHost + "sitegroups/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.siteGroupsList = result;
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.siteGroupsList;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
                if(self.savedSiteGroupIndex) {
                    self.gridOptions.api.ensureIndexVisible(self.savedSiteGroupIndex, 'middle');
                }

                if(self.gridModifications) {
                    let gm = self.gridModifications;
                    if(gm.columnState) {
                        self.gridOptions.columnApi.setColumnState(gm.columnState);
                    }
                    if(gm.filterModel) {
                        self.gridOptions.api.setFilterModel(gm.filterModel);
                    }
                    if(gm.sortModel) {
                        self.gridOptions.api.setSortModel(gm.sortModel);
                    }
                }
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'siteTags');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle user-tres-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle user-tres-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.user-tres-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.user-tres-action')[1];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            this.editSiteGroup(params.data);
                        },
                        deleteFunction: (params) => {
                            if(!self.lockSave) {
                                this.deleteSiteGroupClick(params.data);
                            }
                        }
                    }
                },
                { 
                    headerName: 'Tag Name', 
                    field: 'site_group_name', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Tag Description', 
                    field: 'site_group_desc', 
                    width: 450, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
            ];
            return columnDefs;
        },

        editSiteGroup: function(siteGroup) {
            this.selectedSiteGroup = JSON.parse(JSON.stringify(siteGroup));
            this.windowPage = 1;
        },

        saveSiteGroup: function(siteGroup, editSites, sites) {
            console.log('saving sites: ', sites);
            TELSA.loading(true);
            let route = (TELSA.apiHost + "sitegroups/edit");
            if(siteGroup.site_group_id == 0) {
                route = (TELSA.apiHost + "sitegroups/add");
            }
            let site_ids = sites.map(s => {return s.site_id});
            this.$http.post(route, {args: {siteGroup: siteGroup, editSites: editSites, sites: site_ids}}).then(response => {
                let result = response.body;
                this.windowPage = 0;
                if(siteGroup.site_group_id) {
                    this.savedSiteGroupIndex = this.siteGroupsList.findIndex(s => s.site_group_id == siteGroup.site_group_id);
                }
                if(editSites) {
                    this.$store.dispatch('handleRemoveLocks', {});
                }
                Promise.all(this.getPageData()).then(r => {TELSA.loading(false); this.buildAgGrid()});
            });
        },

        deleteSiteGroupClick: function(siteGroup) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete Site Group',
                message: `This operation will delete this group and remove all members from this group. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteSiteGroup(siteGroup)
            });
        },

        deleteSiteGroup: function(siteGroup) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "sitegroups/delete");
            this.$http.post(route, {args: {siteGroup: siteGroup}}).then(response => {
                let result = response.body;
                Promise.all(this.getPageData()).then(r => {TELSA.loading(false); this.buildAgGrid()});
            });
        },

        newSiteGroup: function() {
            this.selectedSiteGroup = {
                site_group_id: 0,
                site_group_name: '',
                site_group_desc: ''
            };
            this.windowPage = 1;
        },

        saveGridModifications: function () {
            TELSA.loading(true);
            let gridState = {
                columnState: this.gridOptions.columnApi.getColumnState(),
                filterModel: this.gridOptions.api.getFilterModel(),
                sortModel: this.gridOptions.api.getSortModel(),
            }
            this.$store.dispatch('setConfigItem', {key: 'site_groups_grid_state', value: JSON.stringify(gridState)}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },

        clearGridModifications: function () {
            let colStates = this.gridOptions.columnApi.getColumnState();
            colStates.forEach(c => c.hide = false);
            this.gridOptions.columnApi.setColumnState(colStates);
            this.gridOptions.api.setFilterModel(null);
            this.gridOptions.api.setSortModel(null);
            this.$store.dispatch('setConfigItem', {key: 'site_groups_grid_state', value: ""}).then(response => { });
        },

        getGridModifications: function () {
            return this.$store.dispatch('getConfigItem', {key: 'site_groups_grid_state'}).then(response => {
                let result = response.body;
                this.gridModifications = result ? JSON.parse(result) : null;
            });
        },

        getPageData: function() {
            let promises = [];
            promises.push(this.getSiteGroupsList());
            promises.push(this.getGridModifications());
            return promises;
        }
    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/site-groups');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){Promise.all(self.getPageData()).then(r => {self.buildAgGrid(); TELSA.loading(false);})}
            });
            this.lockSave = true;
            return;
        }

        let promises = [];
        promises = promises.concat(this.getPageData());
        Promise.all(promises).then(v => {
            this.buildAgGrid();
            TELSA.loading(false);
        });
    }

  
};
</script>

<style scoped>
    .data-container {
        display: block;
        padding: 0;
    } 
</style>

<style scoped>

    #ag-grid-container {
        height: calc(100vh - 126px);
        width: 100%;
    }

</style>

<style>
    .admin-page-grid-center-buttons-container {
        display: inline-block;
        position: fixed;
        left: calc(50% - (68px) - (76px / 2));
        padding: 8px 10px 4px 10px;
        margin-top: 10px;
        border: gray solid 1px;
        border-radius: 5px;
        background-color: #424242;
    }

    .admin-page-grid-center-buttons-container .admin-page-grid-center-buttons-container-label {
        font-size: 11px;
        position: absolute;
        background-color: #303030;
        left: calc(50% - (89px / 2));
        top: -8px;
        padding: 1px 3px 0px 3px;
        height: 8px;
    }

    @media(max-width: 600px) {
        .admin-page-grid-center-buttons-container {
            margin-left: 0px;
            right: 0px;
        }
    }

</style>
